<template>
  <div>
    <section class="top">
      <div class="header">
        <div class="header-svg clouds"></div>
        <div class="container">
          <div class="columns">
            <div class="column is-6">
              <h1 class="title is-1 has-text-left mb-6" ref="logo">Topografie oefenen</h1>
              <p class="subtitle is-5" ref="logotext">Met Ikleeralles.nl leer je de Nederlandse en wereldwijde kaarten uit je hoofd. Moet je de provincies en hoofdsteden van Nederland kennen? Of moet je Europa uit je hoofd leren? Je kunt hier gratis topografie oefenen!</p>
              <div class="buttons">
                <b-button tag="router-link" to="/aanmelden?r=ga-t" type="is-primary" size="is-medium" icon-right="arrow-right">Aan de slag</b-button>
              </div>
            </div>
             <div class="column is-4 is-offset-2">
              <img class="header-image is-hidden-touch" alt="topografie overhoren" src="@/assets/screenshots/topografie-1.png" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero">
      <div class="hero-body mt-5">
        <div class="container">
          <div class="columns">
            <div class="column is-half">
              <img alt="topo nederland" class="pr-5" src="@/assets/screenshots/topografie-2.png" />
            </div>
            <div class="column is-half">
              <div class="lead">
                <h1 class="title">
                  Topo Nederland.
                  <span class="anotherhand">Goed om te weten</span>
                </h1>
                <p class="is-size-4">
                  Ikleeralles.nl is de beste overhoorsite voor het oefenen van topografie. We hebben veel verschillende kaarten voor je klaar staan. Neem bijvoorbeeld de provincies en hoofdsteden van Nederland.
                  <br/><br/>Je kunt ook je eigen kaarten maken om precies te overhoren wat jij wil!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h3 class="title is-2 anotherhand">Klaar om aan de slag te gaan?</h3>
          <b-button tag="router-link" to="/aanmelden?r=ga-t" size="is-large" type="is-success">Registreren</b-button>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>
@use "~@/assets/style/landing.scss";

.video {
  -webkit-box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
</style>
